import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface TradeDataState {
  tradeData: TradeDataTypes[];
}

const initialState: TradeDataState = {
  tradeData: [],
};

export const tradeDataSlice = createSlice({
  name: "tradeData",
  initialState,
  reducers: {
    setTradeData: (
      state,
      { payload }: PayloadAction<TradeDataState["tradeData"]>
    ) => {
      state.tradeData = payload;
    },
    clearTradeData: (state) => {
      state.tradeData = [];
    },
  },
});

export const { setTradeData, clearTradeData } = tradeDataSlice.actions;
